/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetClientDto } from './GetClientDto';
import {
    GetClientDtoFromJSON,
    GetClientDtoFromJSONTyped,
    GetClientDtoToJSON,
} from './GetClientDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';

/**
 * 
 * @export
 * @interface GetBankAccountDto
 */
export interface GetBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetBankAccountDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    invoiceType: GetBankAccountDtoInvoiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    currency: GetBankAccountDtoCurrencyEnum;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetBankAccountDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {GetClientDto}
     * @memberof GetBankAccountDto
     */
    client: GetClientDto;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    swiftBIC: string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    bankName: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetBankAccountDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    vatNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetBankAccountDto
     */
    vatBankName: string;
}


/**
 * @export
 */
export const GetBankAccountDtoInvoiceTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type GetBankAccountDtoInvoiceTypeEnum = typeof GetBankAccountDtoInvoiceTypeEnum[keyof typeof GetBankAccountDtoInvoiceTypeEnum];

/**
 * @export
 */
export const GetBankAccountDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type GetBankAccountDtoCurrencyEnum = typeof GetBankAccountDtoCurrencyEnum[keyof typeof GetBankAccountDtoCurrencyEnum];


/**
 * Check if a given object implements the GetBankAccountDto interface.
 */
export function instanceOfGetBankAccountDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "invoiceType" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "client" in value;
    isInstance = isInstance && "swiftBIC" in value;
    isInstance = isInstance && "bankName" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "vatNumber" in value;
    isInstance = isInstance && "vatBankName" in value;

    return isInstance;
}

export function GetBankAccountDtoFromJSON(json: any): GetBankAccountDto {
    return GetBankAccountDtoFromJSONTyped(json, false);
}

export function GetBankAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBankAccountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'number': json['number'],
        'invoiceType': json['invoiceType'],
        'currency': json['currency'],
        'company': GetCompanyDtoFromJSON(json['company']),
        'client': GetClientDtoFromJSON(json['client']),
        'swiftBIC': json['swiftBIC'],
        'bankName': json['bankName'],
        'active': json['active'],
        'vatNumber': json['vatNumber'],
        'vatBankName': json['vatBankName'],
    };
}

export function GetBankAccountDtoToJSON(value?: GetBankAccountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'number': value.number,
        'invoiceType': value.invoiceType,
        'currency': value.currency,
        'company': GetCompanyDtoToJSON(value.company),
        'client': GetClientDtoToJSON(value.client),
        'swiftBIC': value.swiftBIC,
        'bankName': value.bankName,
        'active': value.active,
        'vatNumber': value.vatNumber,
        'vatBankName': value.vatBankName,
    };
}

